module.exports = __webpack_public_path__ + "assets/img/4.f16f79f7.png";